
const literatureTexts = {
    series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    chartOptions: {
        labels: ["شعر فصيح", "شعر شعبي", "نثر", "رواية", "قصة قصيرة", "نص ادبي", "مذكرات", "خواطر", "مقالات", "كتب", "اخرى" ],
        colors: ["#4E79A7", "#F28E2B", "#E15759", "#76B7B2", "#59A14F", "#EDC948", "#B07AA1", "#FF9DA7", "#9C755F", "#BAB0AC", "#8CD17D"],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
        },
        chart: {
            toolbar: {
                show: true,
            }
        },
        dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex];
            },
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 340
                },
                legend: {
                    show: true
                },
            }
        }]
    }
};

const arts = {
    series: [0, 0, 0, 0, 0, 0],
    chartOptions: {
        labels: ["رسم رقمي", "رسم لوحات", "النحت", "الخزف", "خط", "تصميم الملصقات والبوسترات", "اخرى" ],
        colors: ["#4E79A7", "#F28E2B", "#E15759", "#9C755F", "#76B7B2", "#59A14F", "#8CD17D"],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
        },
        chart: {
            toolbar: {
                show: true,
            }
        },
        dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex];
            },
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 340
                },
                legend: {
                    show: true
                },
            }
        }]
    }
};

const media = {
    series: [0, 0, 0, 0, 0, 0, 0],
    chartOptions: {
        labels: ["صور", "افلام قصيرة", "وثائقية", "رسوم متحركة", "المواقع الالكترونية", "صفحات التواصل الاجتماعي", "اخرى" ],
        colors: ["#59A14F", "#EDC948", "#B07AA1", "#FF9DA7", "#9C755F", "#BAB0AC", "#8CD17D"],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
        },
        chart: {
            toolbar: {
                show: true,
            }
        },
        dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex];
            },
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 340
                },
                legend: {
                    show: true
                },
            }
        }]
    }
};


export { literatureTexts, arts, media };